import { useTranslation } from 'react-i18next';
import { PricingFormInput } from '../../../../store/features/delegate/types';

export function useDelegateAdHocFormTransformedInputFields(
  formInput: PricingFormInput,
) {
  const { t } = useTranslation();

  const fieldName = `adHocAnswers.${formInput.name}`;
  const fieldLabel = formInput.i18nKey ? t(formInput.i18nKey) : formInput.label;
  const fieldRequired = formInput.required || undefined;

  return {
    fieldName,
    fieldLabel,
    fieldRequired,
  };
}
